'use client';

import { CheckIcon, XIcon } from 'lucide-react';
import { useToast } from '../../../../lib/src/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        variant,
        action,
        ...props
      }) {
        return (
          <Toast
            key={id}
            {...props}
          >
            <div className="flex flex-row gap-2">
              {variant === 'default' && (
                <div className="flex size-5 min-w-5 items-center justify-center rounded-full bg-green-400">
                  <CheckIcon className="size-3 text-white" />
                </div>
              )}

              {variant === 'warning' && (
                <div className="flex size-5 min-w-5 items-center justify-center rounded-full bg-yellow-400 text-center">
                  <span className="font-bold text-white">!</span>
                </div>
              )}

              {variant === 'destructive' && (
                <div className="flex size-5 min-w-5 items-center justify-center rounded-full bg-destructive text-center">
                  <XIcon className="size-3 text-white" />
                </div>
              )}

              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
